// extracted by mini-css-extract-plugin
export var box = "_4n-1";
export var checked = "_4n-2";
export var descriptionSpacer = "_4n-9";
export var disabled = "_4n-3";
export var icon = "_4n-6";
export var input = "_4n-0";
export var labelSpacer = "_4n-8";
export var medium = "_4n-5";
export var small = "_4n-4";
export var text = "_4n-7";